import React from 'react';
import { Image } from 'react-feather';

import Button from '../../buttons/Button';
import GalleryImage from './GalleryImage';
import { DisplayImage } from 'components/poi/PoiMediaGallery';

function SingleImage({ image, handlePhotoClick }: { image: DisplayImage; handlePhotoClick: () => void }) {
    if (image.original.height > image.original.width) {
        return (
            <div className="grid gap-2 grid-cols-2 grid-rows-2 max-w-xl h-full relative">
                {/* {isDateInContest(createdAt) && <PhotoContestBadge />} */}
                <div className="row-span-2">
                    <GalleryImage src={image.large.url} alt={image.alt} handleClick={handlePhotoClick} />
                </div>
                <div className="row-span-2 relative">
                    <GalleryImage src="/images/image-placeholder-tall.jpg" alt="Kam za vikend" />
                    <div className="absolute bottom-2 right-2">
                        <Button onClick={handlePhotoClick} startIcon={<Image />} color="white">
                            Odpri galerijo
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
    return (
        <div className="grid gap-2 grid-cols-2 grid-rows-2 h-full relative">
            {/* {isDateInContest(createdAt) && <PhotoContestBadge />} */}
            <div className="row-span-2 col-span-2">
                <GalleryImage src={image.large.url} alt={image.alt} handleClick={handlePhotoClick} />
                <div className="absolute bottom-2 right-2">
                    <Button onClick={handlePhotoClick} startIcon={<Image />} color="white">
                        Odpri galerijo
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default SingleImage;
